import { useMemo } from "react";
import { useFormContext } from "react-hook-form";
import { useEditorHistoryContextOptional } from "../contexts/editor-history-context";

export default function useBlockFormApi(
  section: "before" | "inside" | "after",
  index: number,
) {
  const form = useFormContext();
  const history = useEditorHistoryContextOptional();
  const blockPath = `content.${section}Blocks.${index}`;

  return useMemo(
    () => ({
      blockPath,
      updateField: (path: string, value: unknown) => {
        form.setValue(path, value, { shouldDirty: true, shouldTouch: true });
        setTimeout(() => history?.captureState(), 0);
      },
      getFieldValue: (path: string) => form.getValues(path),
      registerImage: (imageUploadKey: string, file: File | null) => {
        form.setValue(`assets.uploads.${imageUploadKey}`, file, {
          shouldDirty: true,
          shouldTouch: true,
        });
        setTimeout(() => history?.captureState(), 0);
      },
    }),
    [form.setValue, form.getValues, blockPath, history],
  );
}
